import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
    ArticleContainer,
    Paragraph,
    Author,
    SectionTitle,
    PageTitle,
    SubTitle,
    List,
    ListItem,
    HeroImage,
    HeroCaption,
    ImageContainer,
    Image,
    ImageCaption,
    Quote,
    QuoteAuthor,
    Link,
    VideoContainer,
    TextContainer,
    Video
} from '../../styles/exhibitionStyles';


const BoyAndPlant = () => {
    useEffect(() => {
        document.title = "The Boy and The Plant: Sleepr";
    }, []);

    return (
        <ArticleContainer>
            <HeroImage src="\img\articles\acuminata.jpg" alt="Sleepr photo" />
            {/* <HeroCaption>Acacia acuminata (Sleepr, 2009)</HeroCaption> */}

            <PageTitle>The Boy and The Plant</PageTitle>
            <Author>By Lauren McMahon</Author>
            <TextContainer>
                <Paragraph>
                    On a night like any other, though a little different than before. In his bed, a little boy lay<br />
                    half asleep, when a plant knocked at his door.
                </Paragraph>

                <Paragraph>
                    Half asleep, is a very ordinary place for little boys to be. Half here, half there, not quite<br />
                    anywhere really, but somewhere in-between.
                </Paragraph>

                <Paragraph>Again, came a knock.</Paragraph>

                <Paragraph>
                    The little boy thought <em>come in, come in!</em> To whomever the knock at his door<br />
                    might have been.
                </Paragraph>

                <Paragraph>
                    Before him, a plant. <em>A plant?</em> "A plant," said the boy. It felt like meeting himself at the door,<br />
                    or someone, or something he'd met once before.
                </Paragraph>

                <Paragraph>He knew this was no ordinary plant.</Paragraph>

                <Paragraph>
                    "Who are you? " The boy half questioned, unsure why he would. The plant said nothing of<br />
                    course, as plants often should.
                </Paragraph>

                <Paragraph>
                    This plant didn't have to answer to speak. Magic never makes a sound. You have to be<br />
                    still to find it, you have to listen to see.
                </Paragraph>

                <Paragraph>And the plant stayed still.</Paragraph>

                <Paragraph>
                    As if it were here to share a secret. As if it were calling his name, or offering the little boy<br />
                    a chance to see why it came.
                </Paragraph>

                <Paragraph>Then the invocation.</Paragraph>

                <Paragraph>
                    Before him, a doorway. One breath, two breaths, three. Humming somethings, through<br />
                    the doorway, a world. Twisting and bending, wanting to be seen.
                </Paragraph>

                <Paragraph>He blinked once and the world rushed through. The door was wide open now.</Paragraph>

                <Paragraph>
                    Terrified, the boy turned to the plant. "Why am I here? What have you done? Where am I<br />
                    now? What has begun?"
                </Paragraph>

                <Paragraph>Then the plant spoke, as plants often should.</Paragraph>

                <Paragraph>
                    <em>"Perplexity patterns await you,<br />
                        mystery etched into line,<br />
                        endlessness time in a moment,<br />
                        endlessness moments in time.</em>
                </Paragraph>

                <Paragraph>
                    <em>Geometry folds on itself here,<br />
                        this magic knows no law of land,<br />
                        secrets reveal their source here,<br />
                        surrender and offer your hand.</em>
                </Paragraph>

                <Paragraph>
                    <em>This is a something I'll give you,<br />
                        this is how magic is done,<br />
                        you've been here a million times,<br />
                        lifetimes and lifetimes in one."</em>
                </Paragraph>

                <Paragraph>
                    And that's when it hit him, it all became real, and he knew. This place was different. This<br />
                    place was unreal. This place was a place of perfect surreal.
                </Paragraph>

                <Paragraph>This was a something.</Paragraph>

                <Paragraph>
                    The boy, now a sleeper in the dream of a dream. Somethings and everythings happening<br />
                    at once. Unfolding, unscrambling, untangling before him, right here, in this dream of a dream.
                </Paragraph>

                <Paragraph>
                    This was a something, an infinite something he'd not seen before.<br />
                    Except now he had, and the boy was in awe.
                </Paragraph>

                <Paragraph>
                    And like that, the world fell back together. Reforming, restoring, realigning before him.<br />
                    One breath, two breaths, three.
                </Paragraph>

                <Paragraph>Falling back into his bed again, he knew, The world should know too.</Paragraph>

                <Paragraph>
                    <em>But how? I don't know how to show them. I don't know how they'll see. I don't know how to<br />
                        show them when I am only me.</em>
                </Paragraph>

                <Paragraph>The plant spoke again,</Paragraph>

                <Paragraph>
                    <em>"What is it you fear when it's all but a dream?<br />
                        One isn't alone in this dream of a dream.<br />
                        This door is now closing, but you know where to find me,<br />
                        I am the keeper of secrets: One breath, two breaths, three."</em>
                </Paragraph>

                <Paragraph>
                    The little boy said nothing at all, as little boys often do. For he didn't have to answer to<br />
                    know, but it clicked and knew what he knew. It clicked, and he knew what to do.
                </Paragraph>

                <Paragraph>
                    With eyes that were clear, with eyes that were new. With eyes that now knew what eyes<br />
                    ought to do.
                </Paragraph>

                <Paragraph>
                    "You are the sleeper in the dream of a dream" the plant whispered, tugging and pulling<br />
                    the thread of the dream.
                </Paragraph>

                <Paragraph>Exposing a secret. Unraveling the seam.</Paragraph>
            </TextContainer>
        </ArticleContainer>
    );
};

export default BoyAndPlant; 